import isHighContrastTheme from '%evp_theme/brandbook/appearance/isHighContrastTheme';
import { drawStrongInsetRing } from '%evp_theme/brandbook/material/service/strongStroke';

const STANDARD_CONTROL_BORDER_WIDTH = 1;

export function pickForHighContrast(highContrastValue, defaultValue) {
    return theme => (isHighContrastTheme(theme) ? highContrastValue : defaultValue);
}

export function resolveControlBorderWidth(theme) {
    return isHighContrastTheme(theme) ? theme.shape.strongBorderWidth : STANDARD_CONTROL_BORDER_WIDTH;
}

export const CONTROL_BORDER = theme => `${resolveControlBorderWidth(theme)}px solid`;

export function outsideHighContrast(styles) {
    return pickForHighContrast({}, styles);
}

export function createDisabledOpacity(defaultOpacity) {
    return theme => (isHighContrastTheme(theme) ? theme.palette.action.disabledOpacity : defaultOpacity);
}

export function createHighContrastHoverSwapSx(fill = 'primary.main', ink = 'primary.contrastText') {
    return pickForHighContrast({
        '@media (hover: hover)': {
            '&:hover': {
                bgcolor: fill,
                borderColor: fill,
                color: ink,
                '& *': { color: 'inherit' },
            },
        },
    }, {});
}

export function withHighContrastHoverBorder(hoverSx = {}) {
    return theme => (isHighContrastTheme(theme)
        ? {
            ...hoverSx,
            borderColor: 'text.primary',
            borderWidth: theme.shape.strongBorderWidth,
            boxShadow: 'none',
        }
        : hoverSx);
}

export const SUBTLE_BORDER_COLOR = pickForHighContrast('divider', 'grey.100');
export const STRONG_BORDER_COLOR = pickForHighContrast('divider', 'grey.200');
export const POSITIVE_ACCENT_COLOR = pickForHighContrast('text.primary', 'success.main');
export const HOVERED_ICON_BUTTON_BGCOLOR = pickForHighContrast('selection.bg', 'grey.100');
export const PRESSED_ICON_BUTTON_BGCOLOR = pickForHighContrast('selection.bgStrong', 'grey.200');
export const HOVERED_ROW_BGCOLOR = pickForHighContrast('selection.bg', 'grey.50');
export const LINK_TEXT_DECORATION = pickForHighContrast('underline', 'none');
const HOVERED_HIGH_CONTRAST_RING = theme => (isHighContrastTheme(theme)
    ? drawStrongInsetRing(theme, theme.palette.text.primary)
    : undefined);
export const HOVERED_ROW_SX = Object.freeze({ bgcolor: HOVERED_ROW_BGCOLOR, boxShadow: HOVERED_HIGH_CONTRAST_RING });
export const HOVERED_ICON_BUTTON_SX = Object.freeze({
    bgcolor: HOVERED_ICON_BUTTON_BGCOLOR,
    boxShadow: HOVERED_HIGH_CONTRAST_RING,
});
export const HIGH_CONTRAST_HOVER_SWAP_SX = createHighContrastHoverSwapSx();
export const HIGH_CONTRAST_HOVER_HIGHLIGHT_SX = createHighContrastHoverSwapSx('selection.bgStrong', 'text.primary');
export const HIGH_CONTRAST_BADGE_OUTLINE_SX = theme => (isHighContrastTheme(theme)
    ? { boxShadow: drawStrongInsetRing(theme, 'currentColor') }
    : {});
